export const welcomeScreenTexts = [
  '<span>те</span><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span>ло</span>',
  '<span style="opacity:0;">со</span><span>знание</span>',
  '<span>со</span><span style="opacity:0;">знание</span>'
];

export const errorData = {
  title:
    'В данный момент сервер не может обработать запрос, попрбуйте перезагрузить страницу.',
  image: {
    url: '/images-fallback/error.png'
  }
};
